import React, { useRef, useState } from "react";
import * as styles from "./AttributeSelector.module.scss";
import * as textfieldStyles from "@app/components/Textfield/Textfield.module.scss";
import classNames from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@app/components/Button";
import ModalOverlay from "@app/components/Modal";
import { Field, useField } from "formik";
import Additionalnformation from "@app/components/AttributeSelector/Additionalnformation";

const Attribute = ({ label, value, name, className, disabled, icon, isActive, useSingle = false }) => {
	const classes = classNames(
		{
			[styles["attribute"]]: true,
			[styles["is-active"]]: isActive,
			[styles["is-disabled"]]: disabled,
		},
		className,
		"attribute",
	);
	return (
		<Col xs={6} sm={4}>
			<label className={classes}>
				{icon && <img src={icon} alt={label} />}
				<Field type={!useSingle ? "checkbox" : "radio"} name={name} value={value} />
				{label}
			</label>
		</Col>
	);
};

const AttributeSelector = ({ name, useSingle, options, additionalButton = true, expandable = false }) => {
	const AttributeSelectorClassName = classNames(
		{
			[styles["attribute-selector"]]: true,
		},
		"attribute-selector",
	);
	const [{ value }, meta, { setValue }] = useField({ name });
	const [showModal, setShowModal] = useState(false);
	const primaryAttributes = options.filter(({ displayPrimary }) => !!displayPrimary);
	const secondaryAttributes = options.filter(({ displayPrimary }) => !displayPrimary);
	const secondarySelectedAttributes = options.filter(
		({ displayPrimary, value: optValue }) =>
			!displayPrimary && (useSingle ? value === optValue : value?.includes(optValue)),
	);
	const initialNewAttributes =
		!useSingle && value
			? value
					.filter((val) => {
						return !options.find((opt) => opt.value === val);
					})
					.map((val) => ({
						label: val,
						value: val,
					}))
			: [];
	const [newAttributes, setNewAttributes] = useState(initialNewAttributes);
	const allSecondarySelected = secondaryAttributes.length === secondarySelectedAttributes.length;

	const textFieldClassName = classNames({
		[textfieldStyles["textfield"]]: true,
	});

	const newOptionRef = useRef();
	return (
		<>
			<Container className={AttributeSelectorClassName}>
				<Row className={styles["attributes-row"]}>
					{primaryAttributes.map(({ label, value: optValue, icon }) => (
						<Attribute
							key={`${name}-${optValue}`}
							name={name}
							label={label}
							value={optValue}
							icon={icon}
							useSingle={useSingle}
							isActive={useSingle ? value === optValue : value?.includes(optValue)}
						/>
					))}
					{secondarySelectedAttributes.map(({ label, value: optValue, icon }) => (
						<Attribute
							key={`${name}-${optValue}`}
							name={name}
							label={label}
							value={optValue}
							icon={icon}
							useSingle={useSingle}
							isActive={useSingle ? value === optValue : value?.includes(optValue)}
						/>
					))}
					{newAttributes.map(({ label, value: optValue, icon }) => (
						<Attribute
							key={`${name}-${optValue}`}
							name={name}
							label={label}
							value={optValue}
							icon={icon}
							useSingle={useSingle}
							isActive={useSingle ? value === optValue : value?.includes(optValue)}
						/>
					))}

					{((additionalButton && secondaryAttributes.length > 0) || expandable) && (
						<Col xs={6} sm={4}>
							<Button
								label={"Hinzufügen"}
								type={"quaternary"}
								big={true}
								iconBefore={"add"}
								iconSize={12}
								className={"w-100 additional-button"}
								callback={() => setShowModal(!showModal)}
								disabled={!!allSecondarySelected && !expandable}
							/>
						</Col>
					)}
				</Row>
				{meta.error && (
					<Row>
						<Col>{meta.error}</Col>
					</Row>
				)}

				<Additionalnformation name={`${name}`} value={value} options={options} />
			</Container>

			<ModalOverlay header={"Merkmale hinzufügen"} show={showModal}>
				<Container className={styles["modal-container"]}>
					<Row>
						{secondaryAttributes.map(({ label, value: optValue }) => (
							<Attribute
								key={`${name}-${optValue}`}
								name={`${name}`}
								label={label}
								value={optValue}
								isActive={useSingle ? value === optValue : value?.includes(optValue)}
							/>
						))}
						{expandable && (
							<div className={textFieldClassName}>
								<input
									type={"text"}
									className={"form-control"}
									name={`${name}-newOption`}
									ref={newOptionRef}
									placeholder={"zusätzlicher Eintrag"}
								/>
							</div>
						)}
						<div className={"modal-buttons"}>
							<Button
								type={"primary"}
								label={"Schließen"}
								callback={() => {
									if (expandable) {
										const newAttribute = newOptionRef.current.value;
										if (newAttribute !== "") {
											setValue([...value, newAttribute]);
											setNewAttributes([
												...newAttributes,
												{
													label: newAttribute,
													value: newAttribute,
												},
											]);
										}
									}
									setShowModal(false);
								}}
							/>
						</div>
					</Row>
				</Container>
			</ModalOverlay>
		</>
	);
};

AttributeSelector.propTypes = {};

export default AttributeSelector;
